import styles from "./Page.module.css";

// Generic page container — every sub-page (about, faq, sfma, etc.)
// wraps its content in <Page> so they share consistent gutters and
// the post-fixed-header top spacing without duplicating CSS.
export default function Page({ children, narrow = false, className = "" }) {
  return (
    <div className={[styles.page, narrow ? styles.narrow : "", className].join(" ")}>
      {children}
    </div>
  );
}

export function PageHero({ eyebrow, title, lede, image }) {
  return (
    <section
      className={styles.hero}
      style={image ? { backgroundImage: `url(${image})` } : undefined}
    >
      <div className={styles.heroInner}>
        {eyebrow && <span className={styles.heroEyebrow}>{eyebrow}</span>}
        <h1 className={styles.heroTitle}>{title}</h1>
        {lede && <p className={styles.heroLede}>{lede}</p>}
      </div>
    </section>
  );
}
